import {ActionReducer, ActionReducerMap, combineReducers, createFeatureSelector, createSelector} from '@ngrx/store';
import * as fromManager from './manager.reducer';
import * as fromFreelancer from '../../../freelancers/store/reducers';


export interface ManagerState {
  managers: fromManager.ManagerState;
}

export const reducers: ActionReducerMap<ManagerState> = {
  managers: fromManager.reducer,
};

export const reducer: ActionReducer<ManagerState> = combineReducers(reducers);

export const getManagerState = createFeatureSelector<ManagerState>('managerFeature');



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/managers/store/reducers/index.ts